<template>
  <footer class="copyright-one">
    <div
      class="copyright-container"
      :style="{
        'background-color': configDataForm.backgroundColor,
        color: configDataForm.fontColor,
      }"
      @mouseenter="handleShowOperationBtn(props.showEditContentButton)"
      @mouseleave="handleShowOperationBtn(false)"
    >
      <p
        v-for="item in configDataForm.items"
        :key="item"
        class="copyright-item"
        :class="item.type == 2 && item.iconFullUrl ? 'has-icon' : ''"
      >
        <a
          v-if="item.type == 1 && item.linkUrl"
          :style="{
            color: configDataForm.fontColor,
          }"
          :href="item.linkUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="copyright-link"
        >
          {{ item.text }}
        </a>
        <span
          v-else-if="item.type == 1"
          :style="{
            color: configDataForm.fontColor,
          }"
          class="copyright-text"
        >
          {{ item.text }}
        </span>
        <img v-else :src="item.iconFullUrl || noUpload" alt="备案图标" loading="lazy" class="copyright-icon" />
      </p>
      <operation-container
        v-if="showOperationBtn && !showEditForm"
        :component-data="props.componentData"
        :show-edit-content-button="props.showEditContentButton"
        :show-edit-components-button="props.showEditComponentsButton"
        :show-delete-components-button="props.showDeleteComponentsButton"
        :show-insert-components-button="props.showInsertComponentsButton"
        :show-sort-components-button="props.showSortComponentsButton"
        @handle-show-edit-form="handleShowEditForm"
        @handle-change-components="handleChangeComponents"
        @handle-delete-components="handleDeleteComponents"
        @handle-insert-components="handleInsertComponents"
        @handle-sort-components="handleSortComponents"
      ></operation-container>
    </div>
    <el-drawer
      v-if="showEditForm"
      v-model="showEditForm"
      size="60%"
      :title="props.componentData.componentName"
    >
      <copyright-edit-form
        v-if="showEditForm"
        v-model="configDataForm"
        :component-data="props.componentData"
        @handle-show-edit-form="handleShowEditForm"
        @handle-edit-components-content="handleEditComponentsContent"
      ></copyright-edit-form>
    </el-drawer>
  </footer>
</template>

<script setup>
// #region 引用
import OperationContainer from '../common/OperationContainer.vue';
import copyrightEditForm from './CopyrightEditForm.vue';
// #endregion

// #region props/emit
/**
 * 属性
 */
const props = defineProps({
  showEditContentButton: {
    type: Boolean,
    default: true,
  },
  showEditComponentsButton: {
    type: Boolean,
    default: false,
  },
  showDeleteComponentsButton: {
    type: Boolean,
    default: false,
  },
  showInsertComponentsButton: {
    type: Boolean,
    default: false,
  },
  showSortComponentsButton: {
    type: Boolean,
    default: false,
  },
  componentData: {
    type: Object,
    default() {},
  },
});

// console.log('props-configDataForm:', props);

/**
 * 方法
 */
const emits = defineEmits([
  'handle-show-edit-form',
  'handle-change-components',
  'handle-delete-components',
  'handle-insert-components',
  'handle-sort-components',
  'handle-edit-components-content',
  'update:modelValue',
]);

// #endregion

// #region 变量/常量

// 处理图片未上传的情况
// 预加载所有图片（构建时生成映射）
const images = import.meta.glob('@/assets/images/web/common/other/*.png', {
  eager: true,
  query: '?url',
});
// 直接获取目标图片 URL
const noUpload =
  images['/src/assets/images/web/common/other/no-upload.png']?.default;

const configDataForm = ref({
  items: [
    {
      sortNum: 1,
      type: 1,
      text: '版权所有：成都某某莫某科技有限公司',
      linkUrl: 'https://www.baidu.com',
      iconName: '',
      iconFileKey: 'icon1',
      iconNameObj: null,
    },
    {
      sortNum: 3,
      type: 1,
      text: '©2015',
      linkUrl: 'https://www.baidu.com',
      iconName: '',
      iconFileKey: 'icon3',
      iconNameObj: null,
    },
    {
      sortNum: 4,
      type: 1,
      text: '蜀ICP备19xxxx60号',
      linkUrl: 'https://www.baidu.com',
      iconName: '',
      iconFileKey: 'icon4',
      iconNameObj: null,
    },
    {
      sortNum: 2,
      type: 2,
      text: '',
      linkUrl: '',
      iconName: '/src/views/components/website/footer/image/beian.png',
      iconFileKey: 'icon2',
      iconNameObj: null,
    },
    {
      sortNum: 5,
      type: 1,
      text: '川公网安备 5101xxxxxx1419号',
      linkUrl: 'https://www.baidu.com',
      iconName: '',
      iconFileKey: 'icon5',
      iconNameObj: null,
    },
  ],
  backgroundColor: '#000000',
  fontColor: '#ffffff',
});

if (props.componentData.configData) {
  // 服务器渲染的直接调用
  configDataForm.value = JSON.parse(props.componentData.configData);
  configDataForm.value.items.sort((a, b) => {
    return a.sortNum - b.sortNum;
  });
}
// 操作显示按钮控制
const showOperationBtn = ref(false);
// 显示编辑表单
const showEditForm = ref(false);
// #endregion

// #region 生命周期

// #endregion

// #region 业务方法
// 操作显不显示编辑内容按钮
/**
 * 显示
 */
const handleShowOperationBtn = (flag) => {
  showOperationBtn.value = flag;
};
/**
 * 显示编辑表单
 */
const handleShowEditForm = (flag) => {
  showEditForm.value = flag;
};
/**
 * 处理编辑表单内容
 */
const handleEditComponentsContent = (flag) => {
  // console.log('configDataForm--1-CopyrightEditForm:', configDataForm);
  // 待数据更新完成后才执行
  nextTick(() => {
    emits('update:modelValue', configDataForm.value);
    emits('handle-edit-components-content', true);
  });

  handleShowEditForm(flag);
};

/**
 * 改变组件
 */
const handleChangeComponents = () => {
  emits('handle-change-components', true);
};

/**
 * 删除组件
 */
const handleDeleteComponents = () => {
  emits('handle-delete-components', true);
};

/**
 * 插入组件
 */
const handleInsertComponents = () => {
  emits('handle-insert-components');
};
/**
 * 组件排序
 */
const handleSortComponents = (moveObj) => {
  emits('handle-sort-components', moveObj);
};

// #endregion
</script>

<style scoped lang="scss">
@import '@/styles/website/_variables.scss';

.copyright-one {
  width: 100%;
}

/* PC端样式 */
@include pc {
  .copyright-container {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 48px;
    padding: 10px 80px;

    .copyright-item {
      display: inline-flex;
      align-items: center;
      margin: 4px 12px;
      font-size: 14px;
      color: #fff;

      .copyright-link {
        transition: all $website-duration-slow $website-ease-in-out;

        &:hover {
          opacity: 0.8;
        }
      }

      .copyright-icon {
        width: 18px;
        height: 18px;
        object-fit: cover;
      }
    }
  }
}

/* 移动端样式 */
@include mobile {
  .copyright-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 3vw 4vw;
    font-size: 3.5vw;
    line-height: 1.8;
    text-align: center;

    .copyright-item {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin: 1vw 2vw;
      color: #fff;
      @include entrance-animation(fadeIn, 0.3s);
      @include stagger-delay(5, 0.05s);
      position: relative;

      .copyright-link {
        @include underline-effect-center(rgba(255, 255, 255, 0.6));
        transition: all $website-duration-normal $website-ease-in-out;

        &:active {
          opacity: 0.9;
          transform: scale(0.97);
        }
      }

      .copyright-icon {
        width: 4vw;
        height: 4vw;
        object-fit: cover;
        transition: transform $website-duration-normal $website-ease-out;
      }

      &:active .copyright-icon {
        transform: scale(1.1);
      }
    }
  }
}
</style>
